import moment from "moment";
import React from "react";
import { MdOutlineCloudDownload } from "react-icons/md";

export default function BookingDetails({ booking }) {
  const { BookingRef, Result } = booking;
  const { PDFTicket, PDFFareQuote } = Result;
  ;
  const { BookingSummary } = Result;

  return (
    <>
      <tr className="bg-slate-200">
        <td colSpan={4}>
          <h2 className="font-bold text-lg py-1">Booking Details</h2>
        </td>
      </tr>
      <tr>
        <th>PNR Number</th>
        <td>{BookingSummary.PNRNumber}</td>
        <th>Validating Airline</th>
        <td>{BookingSummary.ValidatingAirline}</td>
      </tr>
      <tr>
        <th>Created On</th>
        <td>{moment(BookingSummary.CreatedOn).format('LLL')}</td>
        <th>Updated On</th>
        {moment(BookingSummary.UpdateOn).isValid() && <td>{moment(BookingSummary.UpdateOn).format('LLL')}</td>}
      </tr>
      <tr>
        <th>Origin</th>
        <td>{BookingSummary.Origin}</td>
        <th>Destination</th>
        <td>{BookingSummary.Destination}</td>
      </tr>
      <tr>
        <th>Trip Start</th>
        <td>{moment(BookingSummary.TripStart).format('ll')}</td>
        <th>Trip End</th>
        <td>{moment(BookingSummary.TripEnd).format('ll')}</td>
      </tr>
      <tr>
        <th>Booked By</th>
        <td>{BookingSummary.BookedBy}</td>
        <th>Service Classes</th>
        <td>{BookingSummary.ServiceClases}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td>
          <small className="uppercase block mb-1"><span className={`${BookingSummary.Status == "Ticketed" ? "text-green-600" : ""}`}>{BookingSummary.Status}</span></small>
        </td>
      </tr>
      {BookingSummary.Status == "Ticketed" && <tr>
        <th>PDF Ticket</th>
        <td>
          <a className="text-primary flex items-center" href={PDFTicket} target="_black"><span className="me-1">Download</span><MdOutlineCloudDownload /></a>
        </td>
      </tr>}
      {/* <tr>


        <th>PDF Fare Quote</th>
        <td>
          <a className="text-primary flex items-center" href={PDFFareQuote} target="_black"><span className="me-1">Download</span><MdOutlineCloudDownload /></a>
        </td> 
      </tr>*/}
      <tr><td colSpan={4} className="min-h-5"><span className="invisible">sr-only</span></td></tr>

    </>
  );
}
